import React, { memo } from 'react';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

function CrownWithStars({ ...other }) {
  return (
    <Box {...other}>
      <svg
        width="104"
        height="104"
        viewBox="0 0 104 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="crown_657694">
          <g id="Ellipse 15">
            <circle cx="52" cy="52" r="46" fill="#E0E0FF" />
            <circle cx="52" cy="52" r="46" fill="white" fill-opacity="0.6" />
          </g>
          <path
            id="Vector"
            d="M73.6667 72H31C28.7947 72 27 73.7947 27 76C27 78.2053 28.7947 80 31 80H73.6667C75.872 80 77.6667 78.2053 77.6667 76C77.6667 73.7947 75.872 72 73.6667 72ZM85.6667 37.3333C85.6667 40.0693 83.5867 42.304 80.9307 42.6079L75.7947 69.3333H28.872L23.7359 42.6079C21.0799 42.304 19 40.0693 19 37.3333C19 34.3921 21.3921 32 24.3333 32C27.2746 32 29.6667 34.3921 29.6667 37.3333C29.6667 39.3094 28.5733 41.0186 26.9707 41.9413C30.0534 49.2479 34.888 53.7306 39.3681 53.3253C44.3707 52.9173 48.4508 47.0026 50.7014 37.1066C47.8161 36.3759 45.6668 33.7759 45.6668 30.6667C45.6668 26.9893 48.6561 24 52.3335 24C56.0108 24 59.0001 26.9893 59.0001 30.6667C59.0001 33.776 56.8508 36.376 53.9655 37.1066C56.2161 47.0026 60.2962 52.9173 65.2988 53.3253C69.7975 53.7306 74.6108 49.2479 77.6962 41.9413C76.0935 41.0186 75.0003 39.3092 75.0003 37.3333C75.0003 34.3921 77.3923 32 80.3336 32C83.2746 32 85.6667 34.3921 85.6667 37.3333Z"
            fill="url(#paint0_linear_538_65515)"
          />
          <g id="Group">
            <path
              id="Vector_2"
              d="M29.125 23L27.0789 17.5461L21.625 15.5L27.0789 13.4539L29.125 8L31.1711 13.4539L36.625 15.5L31.1711 17.5461L29.125 23Z"
              fill="url(#paint1_linear_538_65515)"
            />
            <path
              id="Vector_3"
              d="M87.625 70L85.9881 65.6369L81.625 64L85.9881 62.3631L87.625 58L89.2619 62.3631L93.625 64L89.2619 65.6369L87.625 70Z"
              fill="url(#paint2_linear_538_65515)"
            />
            <path
              id="Vector_4"
              d="M12.625 65L11.4098 61.8402L8.25 60.625L11.4098 59.4098L12.625 56.25L13.8402 59.4098L17 60.625L13.8402 61.8402L12.625 65Z"
              fill="url(#paint3_linear_538_65515)"
            />
            <path
              id="Vector_5"
              d="M88.625 28L87.4098 24.8402L84.25 23.625L87.4098 22.4098L88.625 19.25L89.8402 22.4098L93 23.625L89.8402 24.8402L88.625 28Z"
              fill="url(#paint4_linear_538_65515)"
            />
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_538_65515"
            x1="52.3325"
            y1="25.6276"
            x2="52.3325"
            y2="79.9476"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#D55DB8" />
            <stop offset="1" stop-color="#3D49CC" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_538_65515"
            x1="31"
            y1="3"
            x2="30.9999"
            y2="23"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FD6700" />
            <stop offset="1" stop-color="#FFCE00" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_538_65515"
            x1="89.125"
            y1="54"
            x2="89.1249"
            y2="70"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FD6700" />
            <stop offset="1" stop-color="#FFCE00" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_538_65515"
            x1="7"
            y1="55"
            x2="6.99988"
            y2="75"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FD6700" />
            <stop offset="1" stop-color="#FFCE00" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_538_65515"
            x1="83"
            y1="18"
            x2="82.9999"
            y2="38"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FD6700" />
            <stop offset="1" stop-color="#FFCE00" />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
}

export default memo(CrownWithStars);
